<template>
  <div class="modal-wrap mobile-full" :class="{ active: isShowTerm }">
    <div class="modal" @click="closeModal"></div>
    <div class="modal-alert-wrap term">
      <div class="modal-head">
        <h2>{{ title }}</h2>
        <button type="button" @click="closeModal" class="btn-modal-close">
          <img src="@/assets/images/common/ico-24-close.svg" class="ico-24" alt="close" />
        </button>
      </div>
      <div class="modal-cont" v-html="data.content"></div>
      <div class="chk-wrap dual-input" style="padding: 1.3rem 0 0.6rem 1.4rem" v-if="modalType === 'marketing'">
        <Field name="choice" id="choice1" type="radio" value="true" v-model="selectedChoice" />
        <label for="signup_term_3" style="padding: 0 5px"><span></span>{{ $t('signup.term_accept') }}</label>
        <Field name="choice" id="choice2" type="radio" value="false" v-model="selectedChoice" />
        <label for="signup_term_3" style="padding: 0 5px"><span></span>{{ $t('signup.term_decline') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from '@/serverApi';
import { useI18n } from 'vue-i18n';
import { Field } from 'vee-validate';

export default {
  name: 'ModalTerm',
  components: { Field },
  props: {
    modalType: String,
  },
  data() {
    const { t } = useI18n();
    return {
      t,
      isShowTerm: false,
      data: {},
      title: '',
      selectedChoice: false,
    };
  },
  mounted() {},
  watch: {
    isShowTerm(val) {
      if (val) {
        this.loadData();
      }
    },
    selectedChoice(val) {
      if (val === 'true') {
        this.emitter.emit('choiceItem', true);
      } else {
        this.emitter.emit('choiceItem', false);
      }
    },
    $route: {
      handler() {
        this.closeModal();
      },
    },
  },
  methods: {
    closeModal() {
      this.isShowTerm = false;
      document.documentElement.classList.remove('modal-overflow');
      document.body.classList.remove('modal-overflow');
    },
    loadData() {
      this.$log.debug(['loadData', this.modalType]);
      switch (this.modalType) {
        case 'terms':
          this.title = this.t('system.term_2');
          break;
        case 'privacy':
          this.title = this.t('system.term_3');
          break;
        case 'marketing':
          this.title = this.t('system.term_4');
          break;
      }

      const param = {
        board_type: this.modalType,
        locale: this.$i18n.locale,
      };
      postData('/board/detailByType', param).then((res) => {
        this.$log.debug(['postData', res]);
        this.data = res.data;
      });
    },
  },
};
</script>

<style scoped></style>
